module.exports = __webpack_public_path__ + "static/media/m15tj0.61d2c1f9.png";